export enum ListQueryParams {
    Search = 'q',
    Page = 'page',
    SortBy = 'sortBy',
    WorkflowTypes = 'workflowtypes',
    Category = 'category',
    Compliance = 'compliance',
    IsOpenSource = 'isopensource',
    FileType = 'filetype',
    Users = 'users',
    State = 'state',
    IsFeatured = 'isfeatured',
    IsCommunityContent = 'isCommunityContent',
    UserType = 'userType',
    FolderId = 'folderId',
}
